import gql from 'graphql-tag';

export const suggestedWebpageDokkioTagFragment = gql`
  fragment suggestedWebpageDokkioTagFragment on SuggestedWebpageDokkioTag {
    dokkioClass
    accountID
    webpageID
    dokkioTagID
  }
`;
export default suggestedWebpageDokkioTagFragment;
